module.exports = __webpack_public_path__ + "assets/img/IMG030.f691a2a7.png";